import { createHashRouter, RouterProvider } from "react-router-dom";

import ModuleEmptyPage from "../components/emptyPage";
import ModuleEmbedLayout from "../components/embedLayout";
import BackLayoutMain from "../components/backLayout/main";
import BackHome from "../page/back/home";

import EmbedRoutes from "./embed";
import BackRoutes from "./back";

export default function CreatRoute() {
  const router = createHashRouter([
    {
      path: "",
      element: <BackLayoutMain />,
      children: [{ path: "", element: <BackHome /> }, ...BackRoutes.routes],
    },
    {
      path: "embed",
      element: <ModuleEmbedLayout />,
      children: [...EmbedRoutes.routes],
    },
    { path: "*", element: <ModuleEmptyPage /> },
  ]);

  return <RouterProvider router={router} />;
}
